var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.226 9.858c0-2.337 1.657-4.108 4.047-4.108s4.046 1.77 4.046 4.108v2.832a3 3 0 0 0 .284 1.274l.18.385H7.661l.019-.026a3 3 0 0 0 .546-1.727zm4.047-6.108c-3.562 0-6.047 2.735-6.047 6.108v2.738a1 1 0 0 1-.182.576l-1.127 1.601a1 1 0 0 0 .818 1.576h12.622a1 1 0 0 0 .906-1.425l-.85-1.81a1 1 0 0 1-.094-.424V9.858c0-3.373-2.485-6.108-6.046-6.108m-1.015 14.174a1 1 0 1 0-2 0c0 1.637 1.593 2.574 3.015 2.574s3.015-.937 3.015-2.575a1 1 0 1 0-2 0c0 .068-.032.19-.206.326-.175.137-.458.25-.81.25-.35 0-.633-.113-.809-.25-.173-.136-.205-.258-.205-.325",
    clipRule: "evenodd"
  })));
};
export default SvgNotification;